"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icon = require("../icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getValueFromAccessor = function getValueFromAccessor(_ref) {
  var data = _ref.data,
    accessor = _ref.accessor;
  return accessor.split(".").reduce(function (o, i) {
    return o[i];
  }, data);
};
var SortArrow = function SortArrow(_ref2) {
  var direction = _ref2.direction;
  if (direction === "asc") {
    return /*#__PURE__*/_react["default"].createElement(_icon.Icon, {
      glyphName: "expand_less",
      className: "!text-sm !absolute -right-4 -top-1"
    });
  }
  if (direction === "desc") {
    return /*#__PURE__*/_react["default"].createElement(_icon.Icon, {
      glyphName: "expand_more",
      className: "!text-sm !absolute -right-4 -top-1"
    });
  }
  return null;
};
var Table = exports.Table = function Table(_ref3) {
  var columns = _ref3.columns,
    data = _ref3.data,
    onRowClick = _ref3.onRowClick;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    sortConfig = _useState2[0],
    setSortConfig = _useState2[1];
  var sortedData = (0, _react.useMemo)(function () {
    var sortableItems = _toConsumableArray(data);
    if (sortConfig !== null) {
      sortableItems.sort(function (a, b) {
        var aValue = getValueFromAccessor({
          data: a,
          accessor: sortConfig.key
        });
        var bValue = getValueFromAccessor({
          data: b,
          accessor: sortConfig.key
        });
        return aValue < bValue ? sortConfig.direction === "asc" ? -1 : 1 : aValue > bValue ? sortConfig.direction === "asc" ? 1 : -1 : 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);
  var requestSort = function requestSort(key) {
    var direction = "asc";
    if (sortConfig && sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({
      key: key,
      direction: direction
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-x-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "md:flex hidden font-semibold px-[24px] py-[12px] border-b border-blue-50"
  }, columns.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: column.accessor,
      className: "uppercase w-full px-[4px] text-left outline-none flex text-xs ".concat(column.maxContentWidth ? "whitespace-nowrap" : ""),
      style: column.maxContentWidth ? {
        maxWidth: "fit-content"
      } : {},
      onClick: function onClick() {
        return requestSort(column.accessor);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "relative"
    }, column.Header, column.isSortable && (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.key) === column.accessor && /*#__PURE__*/_react["default"].createElement(SortArrow, {
      direction: sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.direction
    })));
  })), sortedData.map(function (row, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "\n            flex md:flex-row flex-col \n            px-[24px] \n            border-b border-blue-50 w-full \n            focus:outline-none \n            focus:ring-2 focus:ring-blue-600 hover:bg-slate-50 \n            items-center text-base\n         "
    }, columns.map(function (column) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: column.accessor,
        className: "w-full px-[4px] py-[12px] text-left ".concat(column.maxContentWidth ? "whitespace-nowrap" : ""),
        style: column.maxContentWidth ? {
          maxWidth: "fit-content"
        } : {},
        onClick: function onClick() {
          return !column.isClickable && onRowClick({
            row: row
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "md:hidden font-semibold"
      }, column.Header, ":"), column.Cell ? column.Cell({
        row: row
      }) : getValueFromAccessor({
        accessor: column.accessor,
        data: row
      }));
    }));
  }));
};
Table.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    Header: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]).isRequired,
    accessor: _propTypes["default"].string.isRequired,
    isSortable: _propTypes["default"].bool,
    Cell: _propTypes["default"].func,
    maxContentWidth: _propTypes["default"].bool // New property
  })).isRequired,
  data: _propTypes["default"].array.isRequired,
  onRowClick: _propTypes["default"].func
};
Table.defaultProps = {
  onRowClick: function onRowClick() {}
};